import { useDispatch, TypedUseSelectorHook, useSelector } from 'react-redux';
import { configureStore } from '@reduxjs/toolkit';
import commonReducer from 'features/common/commonSlice';
import riskManagementReducer from 'features/riskManagement/riskManagementSlice';
import listPostReducer from 'features/listPost/listPostSlice';
import pushNotificationReducer from 'features/pushNotification/listNotificationsSlice';

export const store = configureStore({
  devTools: true,
  reducer: {
    common: commonReducer,
    riskManagement: riskManagementReducer,
    listPosts: listPostReducer,
    pushNotification: pushNotificationReducer
  }
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch: () => AppDispatch = useDispatch; // Export a hook that can be reused to resolve types
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
